import { render } from "./ITEM_UPDATE_SEVERITYLEVEL.vue?vue&type=template&id=6f5ffe31&ts=true"
import script from "./ITEM_UPDATE_SEVERITYLEVEL.vue?vue&type=script&lang=ts"
export * from "./ITEM_UPDATE_SEVERITYLEVEL.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__